import {needAuth} from "../instance/Instance";

async function getInspectionReportCodeList(search, pageable) {
    console.log(">> 점검보고서관리 코드 List 조회")

    let pageStr="";
    let sort="sort=";
    let size='&size=';
    let page='&page=';
    const desc = ',desc';
    if(pageable.sort) {
        sort += pageable.sort
        if (pageable.desc) {
            sort += desc;
        }
    }

    if(pageable.size){
        size +=pageable.size;
    }
    page +=pageable.page;
    pageStr=sort+size+page;

    try{
        return  await needAuth.post(`/settings/report/inspectionReportCode?`+pageStr,search);
    }catch (error){
        return error;
    }
}

async function getInspectionReportCodeUsedAsset(search, pageable) {
    console.log(">> 점검보고서관리 코드 List 조회")

    let pageStr="";
    let sort="sort=";
    let size='&size=';
    let page='&page=';
    const desc = ',desc';
    if(pageable.sort) {
        sort += pageable.sort
        if (pageable.desc) {
            sort += desc;
        }
    }

    if(pageable.size){
        size +=pageable.size;
    }
    page +=pageable.page;
    pageStr=sort+size+page;

    search = {...search, type : "code"};

    try{
        return  await needAuth.post(`/settings/report/inspectionReportCode?`+pageStr,search);
    }catch (error){
        return error;
    }
}

async function getInspectionReportCodeUsedCompany(search, pageable) {
    console.log(">> 점검보고서관리 코드 List 조회")

    let pageStr="";
    let sort="sort=";
    let size='&size=';
    let page='&page=';
    const desc = ',desc';
    if(pageable.sort) {
        sort += pageable.sort
        if (pageable.desc) {
            sort += desc;
        }
    }

    if(pageable.size){
        size +=pageable.size;
    }
    page +=pageable.page;
    pageStr=sort+size+page;

    search = {...search, type : "company"};

    try{
        return  await needAuth.post(`/settings/report/inspectionReportCode?`+pageStr,search);
    }catch (error){
        return error;
    }
}

async function removeInspectionReportCodes(ids) {
    return await needAuth.put('/settings/report/inspectionReportCode/delete', ids);
}

async function getInspectionReportCode(id) {
    return await needAuth.get('/settings/report/inspectionReportCode/'+id);
}

async function saveInspectionReportCode(data) {
    return await needAuth.post(`/settings/report/inspectionReportCode/create`, data);
}

async function updateInspectionReportCode(data) {
    return await needAuth.post(`/settings/report/inspectionReportCode/update`, data);
}

export {
    getInspectionReportCodeList,
    removeInspectionReportCodes,
    saveInspectionReportCode,
    getInspectionReportCode,
    updateInspectionReportCode,
    getInspectionReportCodeUsedAsset,
    getInspectionReportCodeUsedCompany
}